import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import MarketWatchPage from './pages/MarketWatchPage';
import IPOListPage from './pages/IPOListPage';
import IPODetailsPage from './pages/IPODetailsPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/market-watch" element={<MarketWatchPage />} />
          <Route path="/ipos" element={<IPOListPage />} />
          <Route path="/ipo/:id" element={<IPODetailsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;